export default function roundedTabs() {
  function addTabtoSection(section, placement) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const tabWrapper =
      placement === 'bottom'
        ? section.querySelector('.tab-wrapper-bottom')
        : section.querySelector('.tab-wrapper-top');
    const el = document.createElement('div');

    // eslint-disable-next-line func-names
    const settings = (function() {
      const o = {};

      o.background_color =
        window.getComputedStyle(section).backgroundColor || null;

      if (placement === 'bottom') {
        o.data = section.getAttribute('data-wui-tab-bottom');
      } else {
        o.data = section.getAttribute('data-wui-tab-top');
      }

      if (o.data.indexOf('right') !== -1) {
        o.alignment = 'right';
      } else if (o.data.indexOf('full') !== -1) {
        o.alignment = 'full';
      } else {
        o.alignment = 'left';
      }

      if (o.data.indexOf('25') !== -1) {
        o.width = '25';
      } else if (o.data.indexOf('33') !== -1) {
        o.width = '33';
      } else if (o.data.indexOf('50') !== -1) {
        o.width = '50';
      } else if (o.data.indexOf('66') !== -1) {
        o.width = '66';
      } else {
        o.width = '100';
      }

      return o;
    })();

    let cornerRadius;

    function flipContext() {
      context.translate(canvas.width, canvas.height);
      context.rotate((180 * Math.PI) / 180);
    }

    function setClasses() {
      const classes = [];

      classes.push(`tab-${placement}`);
      classes.push(`tab-${settings.alignment}`);
      classes.push(`w-${settings.width}`);

      return classes.join(' ');
    }

    function drawFullCurve() {
      context.save();

      if (placement === 'bottom') {
        flipContext();
      }

      context.beginPath();
      context.moveTo(0, canvas.height);
      context.quadraticCurveTo(0, 0, cornerRadius, 0, cornerRadius);
      context.lineTo(canvas.width - cornerRadius, 0);

      context.quadraticCurveTo(
        canvas.width,
        0,
        canvas.width,
        canvas.height,
        cornerRadius
      );

      context.closePath();

      context.fillStyle = settings.background_color;

      context.fill();

      context.restore();
    }

    function drawRightCurve() {
      context.save();

      if (placement === 'bottom') {
        flipContext();
      }

      context.beginPath();
      context.moveTo(0, 0);
      context.lineTo(canvas.width - cornerRadius, 0);
      context.quadraticCurveTo(
        canvas.width - cornerRadius / 2,
        0,
        canvas.width - cornerRadius / 2,
        canvas.height / 2,
        cornerRadius / 2
      );
      context.quadraticCurveTo(
        canvas.width - cornerRadius / 2,
        canvas.height,
        canvas.width,
        canvas.height,
        cornerRadius / 2
      );
      context.lineTo(0, canvas.height);
      context.closePath();

      context.fillStyle = settings.background_color;
      context.fill();

      context.restore();
    }

    function drawLeftCurve() {
      context.save();

      if (placement === 'bottom') {
        flipContext();
      }

      context.beginPath();
      context.moveTo(canvas.width, 0);
      context.lineTo(canvas.width, canvas.height);
      context.lineTo(0, canvas.height);
      context.quadraticCurveTo(
        0 + cornerRadius / 2,
        canvas.height,
        0 + cornerRadius / 2,
        canvas.height / 2,
        cornerRadius
      );

      context.quadraticCurveTo(
        0 + cornerRadius / 2,
        0,
        0 + cornerRadius,
        0,
        cornerRadius
      );

      context.lineTo(canvas.width, 0);
      context.closePath();
      context.fillStyle = settings.background_color;
      context.fill();
      context.restore();
    }

    if (window.wk_ui.checkProcessedStatus(section, placement)) {
      return;
    }

    if (tabWrapper) {
      tabWrapper.appendChild(el);
    }

    el.className = setClasses();

    el.appendChild(canvas);

    cornerRadius = el.getBoundingClientRect().height;

    window.wk_ui.setUpCanvas(canvas);

    switch (settings.alignment) {
      case 'full':
        drawFullCurve();
        break;
      case 'left':
        if (placement === 'top') {
          drawRightCurve();
        } else {
          drawLeftCurve();
        }
        break;
      case 'right':
        if (placement === 'top') {
          drawLeftCurve();
        } else {
          drawRightCurve();
        }

        break;
      default:
        break;
    }

    window.wk_ui.setProcessedStatus(section, placement);
  }


  function addTabstoSections(sectionTops, sectionBottoms) {
    if (sectionTops != null) {
      for (let i = 0; i < sectionTops.length; i += 1) {
        addTabtoSection(sectionTops[i], 'top');
      }
    }

    for (let i = 0; i < sectionBottoms.length; i += 1) {
      addTabtoSection(sectionBottoms[i], 'bottom');
    }
  }

  function enable() {
    const sectionTops = document.querySelectorAll('[data-wui-tab-top]');

    document.addEventListener("DOMContentLoaded", function () {
      const sectionBottoms = document.querySelectorAll('[data-wui-tab-bottom]');
      addTabstoSections(sectionTops, sectionBottoms);
    });
  }


  return {
    addTabtoSection,
    addTabstoSections,
    enable
  };


}
